/* Project Unity stories: the "In their own words" rail and the story video /
   profile modal. They share closures, so they ship together. Loaded by
   snippets/project-unity-stories-section.liquid. */
(function () {
  /* Focus restoration lives in project-unity-core.js (loaded by the header).
     Fall back to a plain focus call if that script is missing. */
  function restoreFocus(el) {
    if (window.ProjectUnity && typeof window.ProjectUnity.restoreFocus === 'function') {
      window.ProjectUnity.restoreFocus(el);
      return;
    }
    if (!el) return;
    el.focus({ preventScroll: true });
  }

  /* Runs follow-up work on the task after the next frame paints, so a tap shows
     its result before anything heavier runs (INP). */
  function afterNextPaint(callback) {
    window.requestAnimationFrame(function () {
      window.setTimeout(callback, 0);
    });
  }

  document.querySelectorAll('[data-project-unity]').forEach(function (root) {
  if (root.dataset.puStoriesReady === 'true') return;
  root.dataset.puStoriesReady = 'true';

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  let cancelStoryHint = function () {};
  let refreshStoryLoop = function () {};
  let rebuildStoryLayout = function () {};

  root.querySelectorAll('[data-story-filter]').forEach(function (filter) {
    filter.addEventListener('click', function () {
      cancelStoryHint();
      const selected = filter.dataset.storyFilter;
      root.querySelectorAll('[data-story-filter]').forEach(function (other) {
        other.classList.toggle('is-active', other === filter);
        other.setAttribute('aria-pressed', other === filter ? 'true' : 'false');
      });
      /* Paint the pressed filter first, then filter and re-clone the rows.
         Rebuilding in the same frame as the tap kept the button from
         responding for over 200 ms on a mid-range phone (INP). */
      window.requestAnimationFrame(function () {
        window.setTimeout(function () {
          stopStoryEmbeds();
          root.querySelectorAll('[data-story-type]:not([data-story-clone="true"])').forEach(function (story) {
            /* data-story-type takes a space-separated list, so a story can sit in more
               than one filter. A single value still behaves exactly as before. */
            var types = (story.dataset.storyType || '').split(/\s+/);
            story.classList.toggle('is-hidden', selected !== 'all' && types.indexOf(selected) === -1);
          });
          storyLayoutBuilt = true;
          rebuildStoryLayout();
        }, 0);
      });
    });
  });

  const storyTrack = root.querySelector('[data-story-row]');
  const storyContentTrack = root.querySelector('[data-story-track]');
  const storySecondaryTrack = root.querySelector('[data-story-row-secondary]');
  const storySecondaryContentTrack = root.querySelector('[data-story-track-secondary]');
  const storyPrevious = root.querySelector('[data-story-prev]');
  const storyNext = root.querySelector('[data-story-next]');
  const storyMobileQuery = window.matchMedia('(max-width: 767px)');
  const originalStories = storyContentTrack ? Array.from(storyContentTrack.querySelectorAll('.pu-story')) : [];

  /* A plus is a promise of an attributable written review. Photography-only
     cards stay visible in the roster, but are deliberately non-interactive. */
  originalStories.forEach(function (story) {
    if (!story.hasAttribute('data-story-profile') || story.dataset.storyCopy) return;
    story.removeAttribute('data-story-profile');
    story.classList.remove('pu-story--profile');
    story.classList.add('pu-story--static');
    story.querySelectorAll('.pu-story__profile-indicator').forEach(function (indicator) { indicator.remove(); });
    story.setAttribute('aria-label', story.dataset.storyPerson + ' testimonial photograph');
    story.setAttribute('tabindex', '-1');
    story.disabled = true;
  });
  let storyLoopStates = [];
  let storyLoopFrame = null;
  let storyLoopPreviousTime = 0;
  let storyLoopInteractionTimer = null;
  const storyLoopPauseReasons = new Set();

  function visibleOriginalStories(track) {
    if (!track) return [];
    return Array.from(track.querySelectorAll('.pu-story:not([data-story-clone="true"]):not(.is-hidden)'));
  }

  function removeStoryClones() {
    root.querySelectorAll('[data-story-clone="true"]').forEach(function (clone) { clone.remove(); });
  }

  function makeStoryClone(story, sourceIndex) {
    const clone = story.cloneNode(true);
    clone.dataset.storyClone = 'true';
    clone.dataset.storySourceIndex = String(sourceIndex);
    clone.setAttribute('aria-hidden', 'true');
    clone.setAttribute('tabindex', '-1');
    clone.querySelectorAll('[tabindex], a, button, video').forEach(function (control) {
      control.setAttribute('tabindex', '-1');
    });
    clone.querySelectorAll('[id]').forEach(function (node) { node.removeAttribute('id'); });
    if (story.dataset.storyVideo) clone.addEventListener('click', function () { openStoryVideo(story); });
    else if (story.hasAttribute('data-story-profile')) clone.addEventListener('click', function () { openStoryProfile(story); });
    return clone;
  }

  function setStoryLoopPause(reason, paused) {
    if (paused) storyLoopPauseReasons.add(reason);
    else {
      storyLoopPauseReasons.delete(reason);
      storyLoopStates.forEach(function (state) { state.position = state.track.scrollLeft; });
    }
    storyLoopPreviousTime = window.performance.now();
  }

  function pauseStoryLoopTemporarily() {
    if (!storyTrack || reducedMotion) return;
    setStoryLoopPause('interaction', true);
    if (storyLoopInteractionTimer) window.clearTimeout(storyLoopInteractionTimer);
    storyLoopInteractionTimer = window.setTimeout(function () {
      setStoryLoopPause('interaction', false);
    }, 2200);
  }

  refreshStoryLoop = function () {
    storyLoopStates.forEach(function (state) {
      const firstOriginal = state.content.querySelector('.pu-story:not([data-story-clone="true"]):not(.is-hidden)');
      const firstClone = state.content.querySelector('.pu-story[data-story-clone="true"]:not(.is-hidden)');
      state.width = firstOriginal && firstClone ? firstClone.offsetLeft - firstOriginal.offsetLeft : 0;
      if (!state.width) {
        state.position = 0;
        state.track.scrollLeft = 0;
      } else if (state.direction < 0) {
        state.position = state.width;
        state.track.scrollLeft = state.width;
      } else {
        state.position = 0;
        state.track.scrollLeft = 0;
      }
    });
    storyLoopPreviousTime = window.performance.now();
  };

  rebuildStoryLayout = function () {
    if (!storyTrack || !storyContentTrack) return;
    removeStoryClones();
    storyLoopStates = [];

    if (storyMobileQuery.matches && storySecondaryTrack) {
      storyLoopPauseReasons.delete('hover');
      let visibleIndex = 0;
      originalStories.forEach(function (story) {
        if (story.classList.contains('is-hidden')) return;
        (visibleIndex % 2 === 0 ? storyContentTrack : storySecondaryContentTrack).appendChild(story);
        visibleIndex += 1;
      });
      originalStories.forEach(function (story) {
        if (story.classList.contains('is-hidden')) storyContentTrack.appendChild(story);
      });
      storyLoopStates = [
        { track: storyTrack, content: storyContentTrack, direction: 1, width: 0, position: 0, dragging: false, moved: false, resumeAt: 0, suppressClickUntil: 0 },
        { track: storySecondaryTrack, content: storySecondaryContentTrack, direction: -1, width: 0, position: 0, dragging: false, moved: false, resumeAt: 0, suppressClickUntil: 0 }
      ];
    } else {
      originalStories.forEach(function (story) { storyContentTrack.appendChild(story); });
      if (storySecondaryContentTrack) storySecondaryContentTrack.replaceChildren();
      storyLoopStates = [{ track: storyTrack, content: storyContentTrack, direction: 1, width: 0, position: 0, dragging: false, moved: false, resumeAt: 0, suppressClickUntil: 0 }];
    }

    if (!reducedMotion) {
      storyLoopStates.forEach(function (state) {
        visibleOriginalStories(state.content).forEach(function (story) {
          state.content.appendChild(makeStoryClone(story, originalStories.indexOf(story)));
        });
      });
    }
    window.requestAnimationFrame(refreshStoryLoop);
  };

  let storiesInView = false;
  function runStoryLoop(now) {
    if (!storyTrack || !storiesInView) { storyLoopFrame = null; return; }
    if (!storyLoopPreviousTime) storyLoopPreviousTime = now;
    const elapsed = Math.min(now - storyLoopPreviousTime, 1000);
    storyLoopPreviousTime = now;
    if (!document.hidden) {
      storyLoopStates.forEach(function (state) {
        if (state.width <= 0) return;
        if (storyMobileQuery.matches) return;
        if (storyLoopPauseReasons.size > 0 || visibleOriginalStories(state.content).length <= 1) return;
        const speed = 60;
        state.position += (elapsed / 1000) * speed * state.direction;
        if (state.position >= state.width) state.position -= state.width;
        if (state.position <= 0) state.position += state.width;
        state.track.scrollLeft = state.position;
      });
    }
    storyLoopFrame = window.requestAnimationFrame(runStoryLoop);
  }

  function moveStories(direction) {
    if (!storyTrack) return;
    pauseStoryLoopTemporarily();
    const card = storyContentTrack.querySelector('.pu-story:not([data-story-clone="true"]):not(.is-hidden)');
    const distance = card ? card.getBoundingClientRect().width + 14 : storyTrack.clientWidth * 0.8;
    const primaryState = storyLoopStates[0];
    if (direction < 0 && primaryState && primaryState.width > 0 && storyTrack.scrollLeft < distance) {
      storyTrack.scrollLeft += primaryState.width;
    }
    storyTrack.scrollBy({ left: distance * direction, behavior: reducedMotion ? 'auto' : 'smooth' });
  }
  cancelStoryHint = pauseStoryLoopTemporarily;
  if (storyPrevious) storyPrevious.addEventListener('click', function () { cancelStoryHint(); moveStories(-1); });
  if (storyNext) storyNext.addEventListener('click', function () { cancelStoryHint(); moveStories(1); });
  [storyTrack, storySecondaryTrack].filter(Boolean).forEach(function (track) {
    const stateForTrack = function () {
      return storyLoopStates.find(function (state) { return state.track === track; });
    };
    const scheduleMobileResume = function (state) {
      if (!state) return;
      track.dataset.userScrolling = 'true';
      if (state.resumeTimer) window.clearTimeout(state.resumeTimer);
      state.resumeTimer = window.setTimeout(function () {
        if (state.width > 0) {
          const normalised = ((track.scrollLeft % state.width) + state.width) % state.width;
          state.position = normalised;
          track.scrollLeft = normalised;
        }
        state.dragging = false;
        track.removeAttribute('data-user-scrolling');
      }, 900);
    };
    const startMobileDrag = function (clientX, pointerType) {
      const state = stateForTrack();
      if (!state) return;
      if (state.resumeTimer) window.clearTimeout(state.resumeTimer);
      state.dragging = true;
      state.moved = false;
      state.startX = clientX;
      state.startScroll = track.scrollLeft;
      state.pointerType = pointerType;
      state.position = track.scrollLeft;
      state.resumeAt = Number.POSITIVE_INFINITY;
      track.dataset.userScrolling = 'true';
    };
    const moveMobileDrag = function (clientX) {
      const state = stateForTrack();
      if (!state || !state.dragging) return;
      if (state.pointerType === 'mouse') {
        track.scrollLeft = state.startScroll + state.startX - clientX;
        state.position = track.scrollLeft;
      }
      if (Math.abs(clientX - state.startX) > 8 || Math.abs(track.scrollLeft - state.startScroll) > 8) state.moved = true;
    };
    const endMobileDrag = function () {
      const state = stateForTrack();
      if (!state || !state.dragging) return;
      const now = window.performance.now();
      state.dragging = false;
      state.position = track.scrollLeft;
      state.resumeAt = now + 900;
      if (state.moved) state.suppressClickUntil = now + 500;
      scheduleMobileResume(state);
    };
    track.addEventListener('pointerenter', function (event) {
      if (!storyMobileQuery.matches && event.pointerType === 'mouse') setStoryLoopPause('hover', true);
    });
    track.addEventListener('pointerleave', function (event) {
      if (!storyMobileQuery.matches && event.pointerType === 'mouse') setStoryLoopPause('hover', false);
    });
    track.addEventListener('pointerdown', function (event) {
      if (storyMobileQuery.matches) startMobileDrag(event.clientX, event.pointerType);
      else setStoryLoopPause('pointer', true);
    });
    track.addEventListener('pointermove', function (event) {
      if (storyMobileQuery.matches) moveMobileDrag(event.clientX);
    }, { passive: true });
    track.addEventListener('pointerup', function () {
      if (storyMobileQuery.matches) endMobileDrag();
      else { setStoryLoopPause('pointer', false); pauseStoryLoopTemporarily(); }
    });
    track.addEventListener('pointercancel', function () {
      if (storyMobileQuery.matches) endMobileDrag();
      else setStoryLoopPause('pointer', false);
    });
    track.addEventListener('scroll', function () {
      if (!storyMobileQuery.matches) return;
      const state = stateForTrack();
      if (!state) return;
      state.position = track.scrollLeft;
      if (state.dragging || track.hasAttribute('data-user-scrolling')) scheduleMobileResume(state);
    }, { passive: true });
    track.addEventListener('click', function (event) {
      if (!storyMobileQuery.matches) return;
      const state = stateForTrack();
      if (!state || (!state.moved && window.performance.now() >= state.suppressClickUntil)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      state.moved = false;
    }, true);
    track.addEventListener('focusin', function () {
      if (!storyMobileQuery.matches) setStoryLoopPause('focus', true);
    });
    track.addEventListener('focusout', function () {
      window.setTimeout(function () {
        if (!storyMobileQuery.matches && !track.contains(document.activeElement)) setStoryLoopPause('focus', false);
      }, 0);
    });
    track.addEventListener('wheel', function () {
      if (storyMobileQuery.matches) {
        const state = stateForTrack();
        if (state) {
          state.position = track.scrollLeft;
          state.resumeAt = window.performance.now() + 900;
          scheduleMobileResume(state);
        }
      } else pauseStoryLoopTemporarily();
    }, { passive: true });
  });
  if (storyMobileQuery.addEventListener) storyMobileQuery.addEventListener('change', rebuildStoryLayout);
  else storyMobileQuery.addListener(rebuildStoryLayout);
  const storiesSection = storyTrack && storyTrack.closest('.pu-stories');
  /* Cloning the roster makes Chrome fetch every lazy story image immediately (about 900 KB)
     and measuring the rail forces layout far below the fold. Build the loop once the stories
     approach the viewport; filters, resizes and breakpoint changes still rebuild as before. */
  let storyLayoutBuilt = false;
  const buildStoryLayoutOnce = function () {
    if (storyLayoutBuilt) return;
    storyLayoutBuilt = true;
    rebuildStoryLayout();
  };
  if (storiesSection && 'IntersectionObserver' in window) {
    const storyApproachObserver = new IntersectionObserver(function (entries) {
      if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
      storyApproachObserver.disconnect();
      buildStoryLayoutOnce();
    }, { rootMargin: '1200px 0px' });
    storyApproachObserver.observe(storiesSection);
    /* Any user activity also builds the rail, so a fast flick never reaches it in its
       single-row server layout. Lighthouse-style loads without interaction stay lazy.
       The build waits until the frame for that first tap, key or scroll has painted:
       cloning and measuring the rail inside the event added 35-40 ms to whatever the
       visitor pressed first, such as the menu button (INP). */
    let storyLayoutQueued = false;
    const queueStoryLayoutBuild = function () {
      if (storyLayoutBuilt || storyLayoutQueued) return;
      storyLayoutQueued = true;
      afterNextPaint(buildStoryLayoutOnce);
    };
    ['scroll', 'touchstart', 'pointerdown', 'keydown', 'wheel'].forEach(function (eventName) {
      window.addEventListener(eventName, queueStoryLayoutBuild, { once: true, passive: true });
    });
  } else buildStoryLayoutOnce();
  function syncStoryVisibility(visible) {
    storiesInView = visible && !document.hidden;
    if (storiesSection) storiesSection.classList.toggle('is-in-view', storiesInView);
    if (storiesInView && !reducedMotion && !storyLoopFrame) {
      storyLoopPreviousTime = 0;
      storyLoopFrame = window.requestAnimationFrame(runStoryLoop);
    } else if (!storiesInView && storyLoopFrame) {
      window.cancelAnimationFrame(storyLoopFrame);
      storyLoopFrame = null;
    }
  }
  let storiesIntersecting = false;
  if (storiesSection && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      storiesIntersecting = entries[0].isIntersecting;
      syncStoryVisibility(storiesIntersecting);
    }).observe(storiesSection);
    document.addEventListener('visibilitychange', function () { syncStoryVisibility(storiesIntersecting); });
  } else syncStoryVisibility(true);

  const storyVideoModal = root.querySelector('[data-story-video-modal]');
  const storyVideoPanel = root.querySelector('[data-story-video-panel]');
  const storyVideoPlayer = root.querySelector('[data-story-video-player]');
  let storyVideoTrack = root.querySelector('[data-story-video-track]');
  const storyProfileImage = root.querySelector('[data-story-profile-image]');
  const storyVideoClose = root.querySelector('[data-story-video-close]');
  const storyVideoTitle = root.querySelector('[data-story-video-title]');
  const storyVideoRole = root.querySelector('[data-story-video-role]');
  const storyVideoCopy = root.querySelector('[data-story-video-copy]');
  const storyVideoOrigin = root.querySelector('[data-story-video-origin]');
  const storyVideoFallback = root.querySelector('[data-story-video-fallback]');
  let storyVideoPreviousFocus = null;
  /* Bumped on every open and close, so work deferred past the first paint is
     dropped when the story was closed (or another opened) in between. */
  let storyModalToken = 0;

  function resetStoryCaption(source) {
    if (!storyVideoTrack) return;
    if (storyVideoTrack.track) storyVideoTrack.track.mode = 'disabled';
    storyVideoTrack.removeAttribute('src');
    const nextTrack = storyVideoTrack.cloneNode(false);
    nextTrack.default = Boolean(source);
    if (source) nextTrack.src = source;
    storyVideoTrack.replaceWith(nextTrack);
    storyVideoTrack = nextTrack;
    if (nextTrack.track) nextTrack.track.mode = source ? 'showing' : 'disabled';
  }

  function sizeStoryVideo() {
    if (!storyVideoPanel || !storyVideoPlayer || !storyVideoPlayer.videoWidth || !storyVideoPlayer.videoHeight) return;
    const ratio = storyVideoPlayer.videoWidth / storyVideoPlayer.videoHeight;
    const horizontalPadding = window.innerWidth < 600 ? 32 : 56;
    const verticalPadding = window.innerWidth < 600 ? 32 : 56;
    const availableWidth = Math.max(240, window.innerWidth - horizontalPadding);
    const availableHeight = Math.max(240, window.innerHeight - verticalPadding);
    const maximumWidth = ratio < 1 ? 480 : 960;
    const width = Math.min(availableWidth, availableHeight * ratio, maximumWidth);
    storyVideoPanel.style.setProperty('--pu-story-video-aspect', String(ratio));
    storyVideoPanel.style.setProperty('--pu-story-video-width', `${Math.round(width)}px`);
    storyVideoPanel.classList.toggle('is-portrait', ratio < 1);
  }

  function stopStoryEmbeds() {
    if (!storyVideoModal || !storyVideoPlayer) return;
    storyModalToken += 1;
    storyVideoPlayer.pause();
    storyVideoPlayer.removeAttribute('src');
    storyVideoPlayer.removeAttribute('poster');
    resetStoryCaption();
    storyVideoPlayer.load();
    storyVideoPlayer.hidden = false;
    if (storyProfileImage) {
      storyProfileImage.removeAttribute('src');
      storyProfileImage.alt = '';
      storyProfileImage.hidden = true;
    }
    storyVideoModal.classList.remove('is-open');
    storyVideoModal.setAttribute('aria-hidden', 'true');
    root.classList.remove('is-story-modal-open');
    if (storyVideoFallback) storyVideoFallback.hidden = true;
    document.documentElement.style.overflow = '';
    setStoryLoopPause('story-video', false);
    restoreFocus(storyVideoPreviousFocus);
    storyVideoPreviousFocus = null;
    storyVideoPanel.style.removeProperty('--pu-story-video-aspect');
    storyVideoPanel.style.removeProperty('--pu-story-video-width');
  }

  function populateStoryModal(trigger) {
    storyVideoPreviousFocus = trigger;
    storyVideoTitle.textContent = trigger.dataset.storyPerson || 'Oxydise story';
    storyVideoRole.textContent = trigger.dataset.storyRole || '';
    storyVideoRole.hidden = !trigger.dataset.storyRole;
    storyVideoOrigin.textContent = trigger.dataset.storyOrigin || 'Original Oxydise story';
    storyVideoCopy.textContent = trigger.dataset.storyCopy || '';
    storyVideoCopy.hidden = !trigger.dataset.storyCopy;
    if (storyVideoFallback) storyVideoFallback.hidden = true;
    storyVideoModal.classList.add('is-open');
    storyVideoModal.setAttribute('aria-hidden', 'false');
    root.classList.add('is-story-modal-open');
    storyVideoPanel.classList.toggle('is-portrait', trigger.dataset.storyFormat !== 'landscape');
    setStoryLoopPause('story-video', true);
    storyVideoPanel.focus({ preventScroll: true });
    /* The modal is a fixed overlay, so it paints first and page scrolling locks on
       the next task, as the mobile menu does: locking inside the tap relayouts the
       page (INP). Skipped if the story was closed in between. */
    storyModalToken += 1;
    const token = storyModalToken;
    afterNextPaint(function () {
      if (token === storyModalToken) document.documentElement.style.overflow = 'hidden';
    });
  }

  function openStoryVideo(trigger) {
    if (!storyVideoModal || !storyVideoPlayer || !trigger.dataset.storyVideo) return;
    if (storyProfileImage) {
      storyProfileImage.removeAttribute('src');
      storyProfileImage.alt = '';
      storyProfileImage.hidden = true;
    }
    storyVideoPlayer.hidden = false;
    storyVideoPlayer.removeAttribute('poster');
    populateStoryModal(trigger);
    /* Paint the open modal first, then attach the film and its captions. Setting
       the source, swapping the caption track and loading inside the tap all ran
       before the modal could paint (story button about 90 ms of script on a
       throttled phone, INP). Nothing plays until the visitor presses play, so the
       film is ready as before. Skipped if the story was closed in between. */
    const token = storyModalToken;
    afterNextPaint(function () {
      if (token !== storyModalToken) return;
      storyVideoPlayer.src = trigger.dataset.storyVideo;
      resetStoryCaption(trigger.dataset.storyCaption);
      storyVideoPlayer.load();
    });
  }

  function openStoryProfile(trigger) {
    if (!storyVideoModal || !storyVideoPlayer || !storyProfileImage || !trigger.dataset.storyPoster) return;
    storyVideoPlayer.pause();
    storyVideoPlayer.removeAttribute('src');
    storyVideoPlayer.removeAttribute('poster');
    resetStoryCaption();
    storyVideoPlayer.load();
    storyVideoPlayer.hidden = true;
    storyProfileImage.src = trigger.dataset.storyPoster;
    storyProfileImage.alt = trigger.dataset.storyPerson || 'Oxydise profile';
    storyProfileImage.hidden = false;
    populateStoryModal(trigger);
  }

  root.querySelectorAll('[data-story-video]:not([data-story-clone="true"])').forEach(function (trigger) {
    trigger.addEventListener('click', function () { openStoryVideo(trigger); });
  });
  root.querySelectorAll('[data-story-profile]:not([data-story-clone="true"])').forEach(function (trigger) {
    trigger.addEventListener('click', function () { openStoryProfile(trigger); });
  });

  if (storyVideoPlayer) {
    storyVideoPlayer.addEventListener('loadedmetadata', function () {
      sizeStoryVideo();
      if (storyVideoPlayer.paused && storyVideoPlayer.currentTime < 0.1 && storyVideoPlayer.duration > 0.1) {
        storyVideoPlayer.currentTime = 0.1;
      }
    });
    storyVideoPlayer.addEventListener('error', function () {
      if (storyVideoFallback && storyVideoModal.classList.contains('is-open') && storyVideoPlayer.getAttribute('src')) {
        storyVideoFallback.hidden = false;
      }
    });
  }
  window.addEventListener('resize', function () {
    if (storyVideoModal && storyVideoModal.classList.contains('is-open')) sizeStoryVideo();
  }, { passive: true });
  if (storyVideoClose) storyVideoClose.addEventListener('click', stopStoryEmbeds);
  if (storyVideoModal) {
    storyVideoModal.addEventListener('click', function (event) {
      if (event.target === storyVideoModal) stopStoryEmbeds();
    });
    document.addEventListener('keydown', function (event) {
      if (!storyVideoModal.classList.contains('is-open')) return;
      if (event.key === 'Escape') {
        stopStoryEmbeds();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = Array.prototype.slice.call(storyVideoModal.querySelectorAll('button, video, [href], [tabindex]:not([tabindex="-1"])'));
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }
  });
})();
